<template>
  <div class="app-wrapper">
    <!-- $vi18n('$i18n# 导航栏 #i18n$') -->
    <Header></Header>
    <!-- $vi18n('$i18n# 内容区域 #i18n$') -->
    <div class="main">
      <Sidebar></Sidebar>
      <div class="content">
        <router-view class="content-wrapper" />
      </div>
    </div>
    <!-- $vi18n('$i18n# 底部栏 #i18n$') -->
    <Footer></Footer>
    <!-- $vi18n('$i18n# 开发者公众号侧边推广弹窗 #i18n$') -->
    <!-- <DeveloperWechatPopup /> -->
  </div>
</template>

<script>
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
// import { DeveloperWechatPopup } from '@mini1/vue2-components';

export default {
  components: {
    Header,
    Sidebar,
    Footer,
    // DeveloperWechatPopup
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: space-between;

  width: 1280px;
  min-height: calc(100vh - 260px);
  margin: 80px auto 30px;
}

.content {
  width: 1056px;
}
</style>
